import React, { useEffect, useMemo, useState } from 'react';
import { TableComponentProps } from './types';
import './style.css';

const TableComponent: React.FC<TableComponentProps> = ({
    heads,
    rows,
    rowsPerPage,
    page,
    totalRows,
    setPage,
    isLoading = false
}) => {
    const [disableNavigation, setDisableNavigation] = useState(true);
    const [start, end] = useMemo(() => {
        if (page && rowsPerPage) {
            const endTemp = page * rowsPerPage;
            return [
                ((page - 1) * rowsPerPage + 1),
                endTemp > totalRows! ? totalRows : endTemp,
            ];
        }
        return [0, 0];
    }, [page, rowsPerPage, totalRows]);
    useEffect(() => {
        setDisableNavigation(false);
    }, [rows]);
    const handleFirst = () => {
        setDisableNavigation(true);
        setPage!(1);
    };
    const handlePrev = () => {
        setDisableNavigation(true);
        setPage!((prev) => prev - 1);
    };
    const handleNext = () => {
        setDisableNavigation(true);
        setPage!((prev) => prev + 1);
    };
    const handleLast = () => {
        setDisableNavigation(true);
        const finalPage = Math.ceil(totalRows! / rowsPerPage!)
        setPage!(finalPage);
    };
    return (
        <div className='d-flex flex-column ps-10 py-2 h-100'>
            <div className='overflow-auto w-100'>
                <table
                    className="table table-border table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 me-n5"
                >
                    <thead>
                        <tr className="text-gray-800 fs-7 text-center">
                            {heads.map((head) => (
                                <th key={`head-${head.code}`} style={{ textAlign: head.textAlign ?? 'center' }}>
                                    {head.label}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {rows.length
                            ? rows.map((row, index) => (
                                <tr key={`row-${index}`}>
                                    {heads.map((head) => (
                                        <td key={`row-${index}-${head.code}`} style={{ textAlign: head.textAlign ?? 'center' }}>
                                            {row[head.code]}
                                        </td>
                                    ))}
                                </tr>
                            ))
                            : <tr>
                                <td colSpan={heads.length} className="text-center text-muted text-center">
                                    {isLoading ? <span className="loading-dots">Cargando</span> : 'Sin registros'}
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
            {!!(rowsPerPage && page) && (
                <div className='footer-table'>
                    <span className='footer-span'>
                        {totalRows ? start : 0}-{end} de {totalRows}
                    </span>
                    <button
                        className='btn-table'
                        onClick={handleFirst}
                        disabled={page === 1 || disableNavigation}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" role="presentation"><path d="M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"></path><path fill="none" d="M24 24H0V0h24v24z"></path></svg>
                    </button>
                    <button
                        className='btn-table'
                        onClick={handlePrev}
                        disabled={page === 1 || disableNavigation}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" role="presentation"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path><path d="M0 0h24v24H0z" fill="none"></path></svg>
                    </button>
                    <button
                        className='btn-table'
                        onClick={handleNext}
                        disabled={end === totalRows || disableNavigation}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" role="presentation"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path><path d="M0 0h24v24H0z" fill="none"></path></svg>
                    </button>
                    <button
                        className='btn-table'
                        onClick={handleLast}
                        disabled={end === totalRows || disableNavigation}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" role="presentation"><path d="M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"></path><path fill="none" d="M0 0h24v24H0V0z"></path></svg>
                    </button>
                </div>
            )}
        </div>
    );
};

export default TableComponent;